import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { useListsStore } from '@shared/model'
import { useDayjs } from '@shared/lib/format'

import { useTutorKanbanStore } from './store'
import { isTutorKanbanExitStage } from '../config/tutor-kanban-exit-stage.const'

interface TutorKanbanExitDetailsReturn {
  isVisible: ComputedRef<boolean>
  refExitRequestDate: ComputedRef<string>
  refExitReason: ComputedRef<string>
}

const EMPTY_VALUE = '—'

export const useTutorKanbanExitDetails = (): TutorKanbanExitDetailsReturn => {
  const tutorKanbanStore = useTutorKanbanStore()
  const listsStore = useListsStore()
  const dayjs = useDayjs()

  const isVisible = computed<boolean>(() => isTutorKanbanExitStage(tutorKanbanStore.getStage))

  const refExitRequestDate = computed<string>(() => {
    const raw = tutorKanbanStore.getTutor?.exit_request_date
    if (!raw) return EMPTY_VALUE

    const date = dayjs(raw)
    return date.isValid() ? date.format(DateFormat.KanbanDate) : raw
  })

  const refExitReason = computed<string>(() => {
    const code = tutorKanbanStore.getTutor?.exit_reason
    if (!code) return EMPTY_VALUE

    return listsStore.getLists?.tutor_exit_reason?.[code] ?? code
  })

  return {
    isVisible,
    refExitRequestDate,
    refExitReason,
  }
}
